import cx from "classnames";
import { useTranslation } from "next-i18next";
import React from "react";

import { isLargeContainer } from "@/utils";

import { Message, Text } from "../elements";
import { Icon } from "../elements/Icon";
import styles from "./styles.module.css";

type DialogProductContainerInfoProps = {
  comparisonNumber: number;
  comparisonSize: number;
  containerSize: number;
};

export const DialogProductContainerInfo = ({
  comparisonNumber,
  comparisonSize,
  containerSize,
}: DialogProductContainerInfoProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.comparison}>
        <Text size="xs">
          <Icon type="container_lg" />
          <span>
            {t(`product_container_info_one_large`, { size: containerSize })}
          </span>
        </Text>
        <Icon type="equals" />
        <Text size="xs">
          <span
            className={cx({ [styles.clip]: isLargeContainer(containerSize) })}
          >
            {[...Array(Math.round(comparisonNumber))].map((_, i) => (
              <Icon type="bottle_lines" key={i} />
            ))}
          </span>
          <span>
            {t("product_container_info_comparison_bottles", {
              numberOfBottles: comparisonNumber,
              bottleSize: comparisonSize,
            })}
          </span>
        </Text>
      </div>

      <Message icon="refill">
        {t("product_container_info_circular_service")}
      </Message>
    </>
  );
};
